'use es6';

import specification from './Specification';
export default specification;